module.exports = "/images/vendor/vue-paycard/src/discover.png?50f9313c2ef8a0b7e6c0c5843b3a8ce6";